import { Controller } from "@hotwired/stimulus"

// FM 기기 승인 / 비활성화 / 재활성화를 서버와 연결하는 Stimulus 컨트롤러
export default class extends Controller {
  static values = { fmId: String }

  connect() {
    this.selectedDeviceId = null
    this.boundKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown)

    // 앱디바이스ID 입력 시 대문자 변환 + 힌트 복원
    const input = this.el("app_device_id")
    if (input) {
      input.addEventListener("input", (e) => {
        e.target.value = e.target.value.toUpperCase()
        this.showHint()
      })
    }
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown)
  }

  // ---- 헬퍼 ----
  el(id) { return this.element.querySelector(`#${id}`) }
  get csrf() { return document.querySelector('meta[name="csrf-token"]').content }

  async patch(suffix, body) {
    try {
      const res = await fetch(`/workplace/organization/field_managers/${this.fmIdValue}/${suffix}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", "X-CSRF-Token": this.csrf },
        body: JSON.stringify(body)
      })
      return await res.json()
    } catch (error) {
      console.error("Device action error:", error)
      alert("처리 중 오류가 발생했습니다.")
      return null
    }
  }

  openModal(id) {
    this.el(id).classList.remove("hidden")
    document.body.style.overflow = "hidden"
    if (typeof lucide !== "undefined") lucide.createIcons()
  }

  closeModal(id) {
    this.el(id).classList.add("hidden")
    document.body.style.overflow = ""
  }

  // ---- 승인 ----
  clearApprovalForm() {
    this.el("app_device_id").value = ""
    this.el("device_memo").value = ""
    this.showHint()
  }

  showHint() {
    this.el("approval-hint").classList.remove("hidden")
    this.el("approval-error").classList.add("hidden")
  }

  showError(message) {
    this.el("approval-hint").classList.add("hidden")
    this.el("approval-error").classList.remove("hidden")
    this.el("approval-error-message").textContent = message
  }

  async approve() {
    const appDeviceId = this.el("app_device_id").value.trim().toUpperCase()
    const memo = this.el("device_memo").value.trim()
    if (!appDeviceId) {
      this.showError("앱디바이스ID를 입력해주세요")
      return
    }

    const result = await this.patch("devices/approve", { app_device_id: appDeviceId, memo })
    if (!result) return

    if (result.success) {
      this.el("approved-device-id").textContent = result.data.app_device_id
      this.el("approved-device-memo").textContent = result.data.memo || "메모 없음"
      this.openModal("approval-success-modal")
    } else {
      this.showError(result.error?.message || "승인에 실패했습니다")
    }
  }

  // ---- 비활성화 ----
  openDeactivateModal(event) {
    this.selectedDeviceId = event.params.id
    this.el("deactivate-device-id").textContent = event.params.appDeviceId
    this.el("deactivate-device-memo").textContent = event.params.memo || "-"
    this.el("deactivate_memo").value = ""
    this.openModal("deactivate-modal")
  }

  closeDeactivateModal() {
    this.closeModal("deactivate-modal")
    this.selectedDeviceId = null
  }

  async confirmDeactivate() {
    const memo = this.el("deactivate_memo").value.trim()
    const result = await this.patch(`devices/${this.selectedDeviceId}/deactivate`, { memo })
    if (!result) return

    if (result.success) {
      location.reload()
    } else {
      alert(result.error?.message || "비활성화에 실패했습니다")
      this.closeDeactivateModal()
    }
  }

  // ---- 재활성화 ----
  async reactivateDevice(event) {
    const result = await this.patch(`devices/${event.params.id}/reactivate`, {})
    if (!result) return

    if (result.success) {
      this.openModal("reactivate-success-modal")
    } else {
      alert(result.error?.message || "재활성화에 실패했습니다")
    }
  }

  // 성공 모달 확인 → 새로고침으로 테이블 갱신
  closeReactivateSuccessModal() { location.reload() }
  closeApprovalSuccessModal() { location.reload() }

  handleKeydown(event) {
    if (event.key !== "Escape") return
    this.closeModal("deactivate-modal")
    // 성공 모달은 단순 숨김 (서버 반영은 이미 완료)
    this.el("reactivate-success-modal")?.classList.add("hidden")
    this.el("approval-success-modal")?.classList.add("hidden")
    document.body.style.overflow = ""
  }
}
